// RU-OPTUI OU-3: an option chain's own source and as_of age, shown wherever a chain drives the UI.
import { useEffect, useState } from "react";
import { chainSourceInfo } from "@/lib/optionChain";

const TONE = {
  live: "border-emerald-500/50 txt-profit",
  warn: "border-yellow-500/50 text-yellow-400",
  bad: "border-red-500/50 txt-loss",
};

export default function ChainSourceBadge({ chain, error = false, nowMs, testid = "chain-source-badge" }) {
  // Re-render every 15 s so the age stays current while the page is open (not when a fixed nowMs is given).
  const [, setTick] = useState(0);
  useEffect(() => {
    if (nowMs !== undefined) return undefined;
    const id = setInterval(() => setTick((n) => n + 1), 15000);
    return () => clearInterval(id);
  }, [nowMs]);
  const info = chainSourceInfo(chain, { error, nowMs: nowMs ?? Date.now() });
  return (
    <span
      data-testid={testid}
      data-source={info.kind}
      className={`inline-flex items-center gap-1.5 border px-2 py-0.5 text-xs font-mono-data ${TONE[info.tone]}`}
    >
      <span className="font-section tracking-wider">{info.label}</span>
      {info.clock && <span className="txt-muted">as of {info.clock} IST</span>}
      {info.age && <span className="txt-muted">({info.age})</span>}
    </span>
  );
}
